// 由 schoolclass/convert.js 自动生成
export const classList = [
  "2023级班级课表",
  "2024级班级课表",
  "2025级班级课表",
  "2026级班级课表",
  "保险221",
  "保险231",
  "保险241",
  "保险251",
  "保险261",
  "财务231",
  "财务232",
  "财务241",
  "财务251",
  "财务261",
  "财务262",
  "储能231",
  "储能232",
  "储能241",
  "储能242",
  "储能251",
  "储能252",
  "储能261",
  "储能262",
  "电力B251",
  "电力B261",
  "电气231",
  "电气2310",
  "电气2311",
  "电气2312",
  "电气2313",
  "电气232",
  "电气233",
  "电气234",
  "电气235",
  "电气236",
  "电气237",
  "电气238",
  "电气239",
  "电气241",
  "电气2410",
  "电气2411",
  "电气2412",
  "电气2413",
  "电气2414",
  "电气242",
  "电气243",
  "电气244",
  "电气245",
  "电气246",
  "电气247",
  "电气248",
  "电气249",
  "电气251",
  "电气2510",
  "电气2511",
  "电气2512",
  "电气2513",
  "电气2514",
  "电气252",
  "电气253",
  "电气254",
  "电气255",
  "电气256",
  "电气257",
  "电气258",
  "电气259",
  "电气261",
  "电气2610",
  "电气2611",
  "电气2612",
  "电气2613",
  "电气2614",
  "电气2615",
  "电气2616",
  "电气2617",
  "电气2618",
  "电气262",
  "电气263",
  "电气264",
  "电气265",
  "电气266",
  "电气267",
  "电气268",
  "电气269",
  "电气B251",
  "电气B252",
  "电气B261",
  "电智231",
  "电智232",
  "电智241",
  "电智242",
  "电智251",
  "电智252",
  "电智253",
  "电智261",
  "电智262",
  "电智263",
  "电子231",
  "电子232",
  "电子241",
  "电子242",
  "电子251",
  "电子252",
  "电子261",
  "电子262",
  "发电Z251",
  "发电Z252",
  "发电Z253",
  "发电Z254",
  "发电Z255",
  "发电Z256",
  "发电Z261",
  "发电Z262",
  "发电Z263",
  "发电Z264",
  "发电Z265",
  "发电Z266",
  "法学231",
  "法学241",
  "法学251",
  "法学261",
  "工程231",
  "工程232",
  "工程241",
  "工程242",
  "工程251",
  "工程252",
  "工程261",
  "工程262",
  "工业231",
  "工业241",
  "工业251",
  "工业252",
  "工业261",
  "工业262",
  "工自Z251",
  "工自Z252",
  "工自Z261",
  "过控231",
  "过控241",
  "过控251",
  "过控261",
  "核科学与工程学院-  核工本231",
  "核科学与工程学院-  核工本232",
  "核科学与工程学院- 辐核本261",
  "核科学与工程学院- 核工本241",
  "核科学与工程学院- 核工本242",
  "核科学与工程学院- 核工本251",
  "核科学与工程学院- 核工本252",
  "核科学与工程学院- 核工本253",
  "核科学与工程学院- 核工本261",
  "核科学与工程学院- 核工本262",
  "核科学与工程学院- 核控制261",
  "机器人231",
  "机器人232",
  "机器人241",
  "机器人242",
  "机器人251",
  "机器人252",
  "机器人261",
  "机器人262",
  "机制231",
  "机制232",
  "机制233",
  "机制234",
  "机制241",
  "机制242",
  "机制243",
  "机制244",
  "机制251",
  "机制252",
  "机制253",
  "机制254",
  "机制261",
  "机制262",
  "机制263",
  "机制264",
  "机制B251",
  "机制B252",
  "机制B253",
  "机制B254",
  "机制B261",
  "机制B262",
  "机制B263",
  "机制B264",
  "计算机231",
  "计算机241",
  "计算机251",
  "计算机252",
  "计算机261",
  "计算机262",
  "计算机B251",
  "计算机B252",
  "计算机B253",
  "计算机B254",
  "计算机B255",
  "计算机B261",
  "计算机B262",
  "计算机B263",
  "计算机B264",
  "计算机B265",
  "继电Z251",
  "继电Z252",
  "继电Z261",
  "继电Z262",
  "继电Z263",
  "建环231班级课表",
  "建环241班级课表",
  "建环251班级课表",
  "建环261班级课表",
  "能动231班级课表",
  "能动232班级课表",
  "能动233班级课表",
  "能动234班级课表",
  "能动235班级课表",
  "能动236班级课表",
  "能动237班级课表",
  "能动238班级课表",
  "能动241班级课表",
  "能动242班级课表",
  "能动243班级课表-717new",
  "能动244班级课表",
  "能动245班级课表",
  "能动246班级课表",
  "能动247班级课表",
  "能动248班级课表-717new",
  "能动251班级课表",
  "能动252班级课表",
  "能动253班级课表",
  "能动254班级课表",
  "能动255班级课表",
  "能动256班级课表",
  "能动257班级课表",
  "能动258班级课表-717new",
  "能动261班级课表-717new",
  "能动262班级课表-717new",
  "能动263班级课表-717new",
  "能动264班级课表-717new",
  "能动265班级课表-717new",
  "能动266班级课表-717new",
  "能动267班级课表",
  "能动268班级课表",
  "能动B251班级课表",
  "能动B252班级课表",
  "能动B261班级课表",
  "能动B262班级课表",
  "能经231",
  "能经241",
  "能经251",
  "能经261",
  "热动Z251",
  "热动Z252",
  "热动Z261",
  "热动Z262",
  "热动Z263",
  "人工智能231",
  "人工智能241",
  "人工智能251",
  "人工智能261",
  "软件231",
  "软件232",
  "软件241",
  "软件242",
  "软件251",
  "软件252",
  "软件261",
  "软件262",
  "软件B251",
  "软件B252",
  "软件B253",
  "软件B261",
  "软件B262",
  "软件B263",
  "社工231",
  "社工241",
  "社工251",
  "社工261",
  "数媒231",
  "数媒241",
  "数媒251",
  "数媒261",
  "通信231",
  "通信232",
  "通信241",
  "通信242",
  "通信251",
  "通信252",
  "通信261",
  "通信262",
  "网安全231",
  "网安全241",
  "网安全251",
  "网安全261",
  "物联网231",
  "物联网241",
  "物联网251",
  "物联网261",
  "物流231",
  "物流232",
  "物流241",
  "物流242",
  "物流251",
  "物流252",
  "物流261",
  "物流262",
  "物业231",
  "物业232",
  "物业241",
  "物业242",
  "物业251",
  "物业252",
  "物业261",
  "物业262",
  "新材料231",
  "新材料232",
  "新材料241",
  "新材料242",
  "新材料251",
  "新材料252",
  "新材料261",
  "新材料262",
  "新能源231",
  "新能源232",
  "新能源233",
  "新能源234",
  "新能源241",
  "新能源242",
  "新能源243",
  "新能源244",
  "新能源251",
  "新能源252",
  "新能源253",
  "新能源254",
  "新能源261",
  "新能源262",
  "新能源263",
  "新能源264",
  "新能源B251",
  "新能源B252",
  "新能源B261",
  "新能源B262",
  "应化231",
  "应化232",
  "应化241",
  "应化242",
  "应化251",
  "应化252",
  "应化261",
  "应化262",
  "智电241",
  "智电251",
  "智电252",
  "智电253",
  "智电261",
  "智电262",
  "智电263",
  "智能231",
  "智能241",
  "智能251",
  "智能261",
  "自动化231",
  "自动化232",
  "自动化233",
  "自动化241",
  "自动化242",
  "自动化243",
  "自动化251",
  "自动化252",
  "自动化253",
  "自动化254",
  "自动化261",
  "自动化262",
  "自动化263",
  "自动化264",
  "自动化B251",
  "自动化B252",
  "自动化B253",
  "自动化B254",
  "自动化B261",
  "自动化B262",
  "自动化B263",
  "自动化B264"
];

export default classList;
